import { WbEnvironmentAccessState } from '@agilelab/plugin-wb-platform';
import { FC, ReactNode } from 'react';

type Props = {
  children?: ReactNode;
};

export const EditorPageEnvironmentLoader: FC<Props> = ({ children }) => (
  <WbEnvironmentAccessState fillAvailableViewport>
    {children}
  </WbEnvironmentAccessState>
);
